exports.NotificationsPageView = require('./NotificationsPageView').default;
